const { isMultibyte, isEmail, } = require('validator');
const { isEmpty } = require('lodash');

const { isCarrierEmail, } = require('../config');

module.exports = {
  fields: () => {
    return {
      email: {
        type: 'string',
        label: 'メールアドレス',
        validations: {
          required: v => !isEmpty(v),
          format: v => !v || isEmail(v),
          notMultibyte: v => !v || !isMultibyte(v),
        },
        warnings: {
          carrierEmail: v => !isCarrierEmail(v),
        },
      },
    };
  },
};
